import React, { Fragment, Suspense, useEffect, useRef, useState } from 'react';
import { faEyeSlash, faFloppyDisk, faListAlt } from '@fortawesome/free-regular-svg-icons';
import { useForm, Controller } from "react-hook-form";
import CommonHeaderContent from '../../../Common/CommonHeaderContent';
import {
    Row,
    Col
} from "reactstrap";
import { faPlus, faClose, faEye, faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getLinkData, setLinkData, showToast,populateCurrentFormDetail } from '../../../Common/Appcommon';
import requestApiService from '../../../services/requestApi.service';
import Loading from '../../../Common/Loading';
import Select from 'react-select';

const SendWebhookAction = (props) => {
    let { closeModal, screenDetail, typeofaction, systemActionSubmit, enableActionDelay, actions, actionIndex } = props;
    const buttonClickRef = useRef();
    const [showLoader, setShowLoader] = useState(false);
    const [formData, setFormData] = useState({ authentication: "no_auth" });
    let [variationList, setVariationsList] = useState([]);
    let [variationCount, setVariationCount] = useState(0);
    const [showPassword, setShowPassword] = useState(false);
    const [inputMode, setInputMode] = useState('custom'); 
    const [formFieldsList, setFormFieldsList] = useState([""]); 
    const [fieldsOptions, setFieldOptions] = useState([]);

    let formDetail = screenDetail.length > 0 ? screenDetail[0] : [];
    let baseformname = formDetail.length > 0 ? formDetail[1] : "";
    const { handleSubmit: handleActionFormSubmit, control, formState: { errors } } = useForm();

    useEffect(() => {
    }, []);

    useEffect(() => {
        (async () => {
            if (actions[actionIndex] !== undefined) {
                let actionData = actions[actionIndex];
                await prepareActionEditor(actionData);
            } else {
                setLinkData([]);
            }
        })();

        return () => {
            // this now gets called when the component unmounts
        };

    }, [actions]);

    useEffect(() => {
        onAddMoreVariants(variationCount);
        return () => {
            // this now gets called when the component unmounts
        };
    }, [variationCount]);

    useEffect(() => {
        (async () => {
            await getWebhookFormFieldsInfo();
        })();
    }, []);

    const prepareActionEditor = async (actionData) => {
        let systemActionStr = actionData['systemActionStr'];
        let tmpFormData = JSON.parse(systemActionStr);
        tmpFormData['action_id'] = actionData['action_id'];
        let linkData = tmpFormData['custom-params'] || [];
        setLinkData(linkData);
        setVariationCount(linkData.length);
        if (tmpFormData['form-fields'] && tmpFormData['form-fields'].length > 0) {
            setFormFieldsList(tmpFormData['form-fields']);
            setInputMode("formfields");
        } else {
            setFormFieldsList([]);
            setInputMode("custom");
        }
        setFormData(tmpFormData);
    };

    const triggerSubmit = () => {
        buttonClickRef.current.click();
    }

    const saveWebhookAction = async () => {
        let tmpFormData = formData;
       // tmpFormData['custom-params'] = getLinkData();
        if (inputMode === "custom") {
            tmpFormData['custom-params'] = getLinkData();
        } else {
            tmpFormData['form-fields'] = formFieldsList.filter(f => f && f.value && f.value.trim() !== "");
        }
        let createTaskParams = formData;
        createTaskParams['action_name'] = formData['webhook_name'];
        createTaskParams['systemActionStr'] = JSON.stringify(tmpFormData);
        createTaskParams["typeofaction"] = typeofaction;
        systemActionSubmit(createTaskParams, actionIndex);
        setLinkData([]);
        enableActionDelay();
        closeModal();
    }

    const onInputChange = async (e) => {
        let { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    }

    const addVariation = () => {
        setVariationCount(prevCount => prevCount + 1);
        onAddMoreVariants(variationCount + 1);

    };

    const onCustomParameterChange = async (e, vi) => {
        let linkData = getLinkData();
        const { name, value } = e.target;
        if (linkData[vi] === undefined) {
            linkData[vi] = {};
        }
        linkData[vi][name] = value;
        setLinkData(linkData);
    }

    const onAddMoreVariants = (variationCount) => {
        let data = getLinkData();
        let vl = [];
        for (let vi = 0; vi < variationCount; vi++) {
            let nl = "custom-key-" + vi;
            let ll = "custom-value-" + vi;
            vl.push(
                <div className='d-flex align-center'>
                    <Col md={6}>
                        <input type="text"
                            defaultValue={data[vi] ? data[vi][nl] : ''}
                            name={nl}
                            onChange={(e) => {
                                onCustomParameterChange(e, vi);
                            }}
                            className="form-control"
                            key={vi}
                            maxLength={40}
                        />
                    </Col>
                    <Col md={6} className='d-flex align-center ps-2'>
                        <input type="text"
                            defaultValue={data[vi] ? data[vi][ll] : ''}
                            name={ll}
                            onChange={(e) => {
                                onCustomParameterChange(e, vi);
                            }}
                            className="form-control"
                            key={vi}
                        />
                        {
                            variationCount > 1 && <a className={`cursor-pointer ml-2`} onClick={() => removeVariations(vi)}>
                                <FontAwesomeIcon icon={faClose} fontSize={14} className={`mr-1 theme-c-g`} />
                            </a>
                        }
                    </Col>
                </div>
            )
        }
        setVariationsList(vl);
    }

    const removeVariations = async (removedIndex) => {
        delete variationList.splice(removedIndex, 1);
        let tmpLinkData = getLinkData();
        let tmpArray = [];
        let newindex = -1;
        for (let i = 0; i < tmpLinkData.length; i++) {
            let data = tmpLinkData[i];
            if (i !== removedIndex) {
                newindex = newindex + 1;
                let newdata = {};
                for (let key in data) {
                    if (key.indexOf('custom-key') > -1) {
                        newdata['custom-key-' + newindex] = data[key];
                    } else if (key.indexOf('custom-value') > -1) {
                        newdata['custom-value-' + newindex] = data[key];
                    }
                }
                tmpArray.push(newdata);
            }
        }
        setLinkData(tmpArray)
        setVariationCount(prevCount => prevCount - 1);
        setVariationsList(variationList);
    }

    const showPasswordAction = () => {
        setShowPassword(!showPassword);
    }

    const onSendTestPayload = async () => {
        let webhook_url = formData['webhook_url']
        let webhook_name = formData['webhook_name']
        if (webhook_name !== undefined && webhook_name !== null && webhook_name !== "" && webhook_url !== undefined && webhook_url !== "") {
            setShowLoader(true);
            let params = {
                "ENTITY": "TEST_WEBHOOK",
                "triggerInfo": formData,
                "formname": baseformname,
            }
            let res = await requestApiService.processServerRequest(params);
            if (res.issuccess) {
                setShowLoader(false);
                showToast("Test Payload sent to given webhook url.");
            }
        } else {
            setShowLoader(false);
            showToast("Webhook Name/Url can't be empty!", "top-right", "warning");
        }
    }
    const getWebhookFormFieldsInfo = async () => {
        let skipFields = [
            `${baseformname}_id`, 'Lead_ID', 'wsapp_recent_activity', 'wsapp_convo_status',
            'wsapp_unread_count', 'wsapp_optin_status', 'wsapp_recent_msg_id',
            'wsapp_enabled', 'wsapp_blocked', 'wsapp_opt', 'wsapp_last_delivered',
            'wsapp_last_read', 'wsapp_last_replied', 'wsapp_last_sent_msg_id',
            'wsapp_completed_campaign'
        ];
        let formDetailArr = await populateCurrentFormDetail([], [], baseformname);
        if (formDetailArr && formDetailArr[1]) {
            let fieldDetails = formDetailArr[1];
            let fields = [];
            let fieldObj = {};
            fieldDetails.forEach(field => {
                const fieldName = field[2];
                const fieldLabel = field[3];
                const fieldType = field[4];
                const isConfigHide = parseInt(field[10]);
                const isViewHide = parseInt(field[11]);
                if (!isConfigHide && !isViewHide &&
                    ![ 'subtable', 'reference_entityid', 'reference_group', 'form_history'].includes(fieldType) &&
                    !skipFields.includes(fieldName)) {
                    fields.push({ value: fieldName, label: fieldLabel });
                    fieldObj[fieldName] = { value: fieldName, label: fieldLabel };
                }
            });
            setFieldOptions(fields);
        }
    };

    const customStyles = {
        control: (base, state) => ({
            ...base,
            borderColor: '#3ac47d',
            boxShadow: state.isFocused ? '0 0 0 1px #3ac47d' : 'none',
            '&:hover': {
            borderColor: '#3ac47d'
            },
        }),
        dropdownIndicator: (base, state) => ({
            ...base,
            color: '#3ac47d',
            '&:hover': {
            color: '#3ac47d'
            },
        }),
        indicatorSeparator: (base) => ({
            ...base,
            backgroundColor: '#3ac47d'
        }),
        singleValue: (base) => ({
            ...base,
            color: '#000000', // Black text for selected value
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? '#e6f4ea' : '#fff',
            color: '#000000', // Default text color for options
            '&:active': {
            backgroundColor: '#d3f0db',
            },
        }),
    };
    let addonButtons = [
        {
            'buttonTxt': "Test Payload",
            'buttonAction': onSendTestPayload,
            'buttonOutline': "",
            'buttonIcon': ""
        }
    ]
    return <Fragment>
        <Loading showLoader={showLoader} mainContent={
            <CommonHeaderContent
                isModal={true}
                closeModal={closeModal}
                headerTitle={"Add Webhook"}
                buttonAction={triggerSubmit}
                buttonTxt={"Save & Close"}
                addonButtons={addonButtons}
                buttonIcon={faFloppyDisk}
                isClassNeeded={false}
                mainContent={
                    <Fragment>
                        <form onSubmit={handleActionFormSubmit(saveWebhookAction)} id="action-form" name="webhook-action">
                            <div className='action-editor-container'>
                                <div className='editor-body'>

                                    <div className='form-conatiner'>
                                        <div className='group-header'>
                                            <div className='editor-header'>
                                                <span className='headerSpan'>Basic Info</span>
                                            </div>
                                            <div className='input-section mt-0 create-task-p10'>
                                                <label className={'workflow-lbl form-label'} htmlFor="webhook_name">Webhook Name</label>
                                                <div className='d-flex-alone align-center'>
                                                    <div className='col-md-12'>
                                                        <Controller
                                                            name="webhook_name"
                                                            control={control}
                                                            rules={{ required: formData.webhook_name !== undefined && formData.webhook_name !== "" ? false : "Please provide Name" }}
                                                            render={({ field }) => {
                                                                return (
                                                                    <input
                                                                        {...field}
                                                                        type="text"
                                                                        name="webhook_name"
                                                                        id="webhook_name"
                                                                        defaultValue={""}
                                                                        value={formData.webhook_name}
                                                                        autoComplete={"off"}
                                                                        onChange={(e) => {
                                                                            onInputChange(e);
                                                                            field.onChange(e);
                                                                        }}
                                                                        className={`form-control ${errors.webhook_name ? 'is-invalid' : ''}`}
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                {errors.webhook_name && <em className={`error invalid-feedback`}>{errors.webhook_name.message}</em>}
                                            </div>
                                            <div className='input-section mt-0 create-task-p10'>
                                                <label className={'workflow-lbl form-label'} htmlFor="webhook_url">Webhook URL</label>
                                                <div className='d-flex-alone align-center'>
                                                    <div className='col-md-12'>
                                                        <Controller
                                                            name="webhook_url"
                                                            control={control}
                                                            rules={{ required: formData.webhook_url !== undefined && formData.webhook_url !== "" ? false : "Please provide URL" }}
                                                            render={({ field }) => {
                                                                return (
                                                                    <input
                                                                        {...field}
                                                                        type="url"
                                                                        placeholder="https://example.com"
                                                                        name="webhook_url"
                                                                        id="webhook_url"
                                                                        defaultValue={""}
                                                                        value={formData.webhook_url}
                                                                        autoComplete={"off"}
                                                                        onChange={(e) => {
                                                                            onInputChange(e);
                                                                            field.onChange(e);
                                                                        }}
                                                                        className={`form-control ${errors.webhook_url ? 'is-invalid' : ''}`}
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                {errors.webhook_url && <em className={`error invalid-feedback`}>{errors.webhook_url.message}</em>}
                                            </div>
                                        </div>
                                        <div className='group-header'>
                                            <div className='editor-header'>
                                                <span className='headerSpan'>Header Info</span>
                                            </div>
                                            <div className='input-section mt-0 create-task-p10'>
                                                <label className={'group-header-lbl form-label hide'} htmlFor="authentication_method">Authentication</label>
                                                <div className={'flex-center-v'} onChange={(event => { onInputChange(event) })}>
                                                    <input type="radio" value="no_auth" checked={formData['authentication'] === "no_auth" || formData['authentication'] === undefined} name="authentication" /> <span className={'custom-pl'}> No authentication</span>
                                                    <input type="radio" value="api_auth" checked={formData['authentication' === "api_auth"]} name="authentication" className='ml-1' /> <span className={'custom-pl'}> API Key</span>
                                                    <input type="radio" value="bearer_token" checked={formData['authentication' === "bearer_token"]} name="authentication" className='ml-1' /> <span className={'custom-pl'}> Bearer Token</span>
                                                    <input type="radio" value="basic" checked={formData['authentication' === "basic"]} name="authentication" className='ml-1' /> <span className={'custom-pl'}> Basic Authentication</span>
                                                    <input type="radio" value="token" checked={formData['authentication' === "token"]} name="authentication" className='ml-1' /> <span className={'custom-pl'}> Token</span>
                                                </div>
                                            </div>
                                            {(formData["authentication"] === "api_auth" || formData["authentication"] === "basic") && <div className='input-section mt-0 create-task-p10 pt-0'>
                                                <div className='d-flex-alone align-center'>
                                                    <div className='col-md-12 d-flex-alone'>
                                                        <div className='col-md-6 pe-1'>
                                                            <label className={'form-label'} htmlFor="api_header_key">{formData["authentication"] === "api_auth" ? "Key" : "Username"}</label>
                                                            <Controller
                                                                name="api_header_key"
                                                                control={control}
                                                                rules={{ required: formData.api_header_key !== undefined && formData.api_header_key !== "" ? false : "Provide header Key" }}
                                                                render={({ field }) => {
                                                                    return (
                                                                        <input
                                                                            {...field}
                                                                            type="text"
                                                                            name="api_header_key"
                                                                            id="api_header_key"
                                                                            defaultValue={""}
                                                                            value={formData.api_header_key}
                                                                            autoComplete={"off"}
                                                                            onChange={(e) => {
                                                                                onInputChange(e);
                                                                                field.onChange(e);
                                                                            }}
                                                                            className={`form-control ${errors.api_header_key ? 'is-invalid' : ''}`}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                            {errors.api_header_key && <em className={`error invalid-feedback`}>{errors.api_header_key.message}</em>}
                                                        </div>
                                                        <div className='col-md-6 ps-1'>
                                                            <label className={'form-label'} htmlFor="api_header_value">{formData["authentication"] === "api_auth" ? "Value" : "Password"}</label>
                                                            <div className='d-flex'>
                                                                <Controller
                                                                    name="api_header_value"
                                                                    control={control}
                                                                    rules={{ required: formData.api_header_value !== undefined && formData.api_header_value !== "" ? false : "Provide header value" }}
                                                                    render={({ field }) => {
                                                                        return (
                                                                            <input
                                                                                {...field}
                                                                                type={formData["authentication"] === "api_auth" || showPassword ? "text" : "password"}
                                                                                name="api_header_value"
                                                                                id="api_header_value"
                                                                                defaultValue={""}
                                                                                value={formData.api_header_value}
                                                                                autoComplete={"off"}
                                                                                onChange={(e) => {
                                                                                    onInputChange(e);
                                                                                    field.onChange(e);
                                                                                }}
                                                                                className={`form-control ${errors.api_header_value ? 'is-invalid' : ''}`}
                                                                            />
                                                                        );
                                                                    }}
                                                                />
                                                                {formData['authentication'] === "basic" && formData['api_header_value'] !== "" &&
                                                                    <a className={`cursor-pointer ml-1`} onClick={() => showPasswordAction()}>
                                                                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} fontSize={14} className={`mr-1 theme-c-g`} />
                                                                    </a>}
                                                            </div>
                                                            {errors.api_header_value && <em className={`error invalid-feedback`}>{errors.api_header_value.message}</em>}

                                                        </div>
                                                    </div>
                                                </div>

                                            </div>}
                                            {(formData['authentication'] === "bearer_token")&& <div className='input-section mt-0 create-task-p10 pt-0'>
                                                <div className='d-flex-alone align-center'>
                                                    <div className='col-md-12 hui'>
                                                        <label className={'form-label'} htmlFor="bearer_token_value">Bearer Token</label>
                                                        <Controller
                                                            name="bearer_token_value"
                                                            control={control}
                                                            rules={{ required: formData.bearer_token_value !== undefined && formData.bearer_token_value !== "" ? false : "Please provide token" }}
                                                            render={({ field }) => {
                                                                return (
                                                                    <input
                                                                        {...field}
                                                                        type="text"
                                                                        name="bearer_token_value"
                                                                        id="bearer_token_value"
                                                                        defaultValue={""}
                                                                        value={formData.bearer_token_value}
                                                                        autoComplete={"off"}
                                                                        onChange={(e) => {
                                                                            onInputChange(e);
                                                                            field.onChange(e);
                                                                        }}
                                                                        className={`form-control ${errors.bearer_token_value ? 'is-invalid' : ''}`}
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                        {errors.bearer_token_value && <em className={`error invalid-feedback`}>{errors.bearer_token_value.message}</em>}
                                                    </div>
                                                    
                                                    
                                                </div>
                                                
                                                    
                                            </div>}
                                            {(formData['authentication'] === "token" && <div className='input-section mt-0 create-task-p10 pt-0'>
                                                <div className='col-md-12'>
                                                                <label className={'form-label'} htmlFor="token_value">Token</label>
                                                                <Controller
                                                                    name="token_value"
                                                                    control={control}
                                                                    rules={{ required: formData.token_value !== undefined && formData.token_value !== "" ? false : "Please provide token" }}
                                                                    render={({ field }) => {
                                                                        return (
                                                                            <input
                                                                                {...field}
                                                                                type="text"
                                                                                name="token_value"
                                                                                id="token_value"
                                                                                defaultValue={""}
                                                                                value={formData.token_value}
                                                                                autoComplete={"off"}
                                                                                onChange={(e) => {
                                                                                    onInputChange(e);
                                                                                    field.onChange(e);
                                                                                }}
                                                                                className={`form-control ${errors.token_value ? 'is-invalid' : ''}`}
                                                                            />
                                                                        );
                                                                    }}
                                                                />
                                                                {errors.token_value && <em className={`error invalid-feedback`}>{errors.token_value.message}</em>}
                                                </div>
                                                </div>)
                                            }
                                        </div>
                                        
                                        <div className='group-header'>
                                            <div className='editor-header'>
                                                <div className='d-flex-alone align-center'>
                                                    <div className='d-flex justify-between align-center'>
                                                        <div className='toggle-tabs d-flex mb-3'>
                                                            <button
                                                                type="button" // <-- important!
                                                                className={`toggle-btn ${inputMode === 'formfields' ? 'active' : ''}`}
                                                                onClick={() => {
                                                                    setInputMode('formfields');
                                                                    if (formFieldsList.length === 0) {
                                                                    setFormFieldsList([{}]);
                                                                    }}}>
                                                               <FontAwesomeIcon icon={faListAlt} className="me-1" /> Configure Fields
                                                            </button>
                                                           <button
                                                                type="button"
                                                                  className={`toggle-btn ${inputMode === 'custom' ? 'active' : ''}`}
                                                                  onClick={() => setInputMode('custom')}>
                                                               <FontAwesomeIcon icon={faSlidersH} className="me-1" /> Custom Parameter
                                                            </button>  
                                                        
                                                        {inputMode === "custom" && (
                                                            <div className={'pl-1'}>
                                                            <a className={`cursor-pointer text-decoration-u`} onClick={(e) => { addVariation(e) }}>
                                                                <FontAwesomeIcon className='theme-c-g' icon={faPlus} /> <span className='theme-c-g'>Add More</span>
                                                            </a>
                                                            </div>
                                                        )}
                                                           
                                                            </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='input-section mt-0 create-task-p10'>
                                                <div className='d-flex-alone align-center'>
                                                    <div className='col-md-12'>
                                                        <div className={`col-md-12  ${(variationList.length > 0 || inputMode === "formfields" ) ? 'd-flex align-center' : 'hide'}`}>
                                                            <Col md={6}>
                                                                <label className='form-label' >Key</label>
                                                            </Col>
                                                            <Col md={6}>
                                                                <label className='form-label ps-2' >Value</label>
                                                            </Col>
                                                        </div>
                                                        {/* {
                                                            variationList.length > 0 &&
                                                            variationList.map((variation) => {
                                                                return variation;
                                                            })
                                                        } */}
                                                           {inputMode === "custom" && variationList.length > 0 && variationList.map((variation) => variation)}
                                                            {inputMode === "formfields" &&
                                                            formFieldsList.map((selected, idx) => (
                                                                <div key={idx} className="d-flex align-items-center mb-2">
                                                                {/* Left: Key Input */}
                                                                <div style={{ flex: 1, marginRight: '6px' }}>
                                                                    <input
                                                                    type="text"
                                                                    placeholder="Enter key name"
                                                                    className="form-control"
                                                                    value={selected?.label || ""}
                                                                    onChange={(e) => {
                                                                        const updatedList = [...formFieldsList];
                                                                        updatedList[idx] = {
                                                                        ...updatedList[idx],
                                                                        label: e.target.value,
                                                                        };
                                                                        setFormFieldsList(updatedList);
                                                                    }}
                                                                    />
                                                                </div>

                                                                {/* Right: Dropdown Input */}
                                                                <div style={{ flex: 1 }}>
                                                                    <Select
                                                                    id={`webhook_field_${idx}`}
                                                                    value={
                                                                        selected && selected.value
                                                                        ? fieldsOptions.find((opt) => opt.value === selected.value)
                                                                        : null
                                                                    }
                                                                    onChange={(selectedOption) => {
                                                                        const updatedList = [...formFieldsList];
                                                                        updatedList[idx] = {
                                                                        ...updatedList[idx],
                                                                        value: selectedOption.value,
                                                                        label: selectedOption.label,
                                                                        };
                                                                        setFormFieldsList(updatedList);
                                                                    }}
                                                                    options={fieldsOptions.filter(
                                                                        (opt) =>
                                                                        !formFieldsList.find(
                                                                            (f) => f?.value === opt.value && f !== selected
                                                                        )
                                                                    )}
                                                                    styles={customStyles}
                                                                    className="basic-single"
                                                                    classNamePrefix="wa-select"
                                                                    placeholder="-- Select Field --"
                                                                    menuPlacement="auto"
                                                                    menuPosition="fixed"
                                                                    />
                                                                </div>

                                                                {/* Action buttons */}
                                                                <a
                                                                    className="cursor-pointer ms-2"
                                                                    onClick={() => {
                                                                    const updatedList = [...formFieldsList];
                                                                    updatedList.splice(idx, 1);
                                                                    setFormFieldsList(updatedList);
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon icon={faClose} className="theme-c-g" />
                                                                </a>

                                                                {idx === formFieldsList.length - 1 && (
                                                                    <a
                                                                    className="cursor-pointer ms-2"
                                                                    onClick={() => setFormFieldsList([...formFieldsList, {}])}
                                                                    >
                                                                    <FontAwesomeIcon icon={faPlus} className="theme-c-g" />
                                                                    </a>
                                                                )}
                                                                </div>
                                                            ))}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='editor-footer modal-footer hide'>
                                    <a onClick={(e) => closeModal(e)} class="btn btn-outline-success">Cancel</a>
                                    <button ref={buttonClickRef} onClick={handleActionFormSubmit(saveWebhookAction)} class="ml-1 btn btn-outline-success">Save</button>
                                </div>
                            </div>
                        </form>
                    </Fragment>
                }
            />
        } />
    </Fragment>
}

export default SendWebhookAction;